import { APP } from '../config/app.js';

/**
 * Every service-area boundary circle drawn by createMap (Book, ActiveRide,
 * TrackRide, PlacePinPicker — anywhere it isn't opted out via
 * showServiceArea:false) registers here, so it can be resized the instant an
 * admin changes serviceRadiusKm live instead of only on the next full map
 * re-init (previously needed an app reopen to catch up).
 *
 * Kept in its own tiny, dependency-free module (not inside maps.js) so this
 * logic is unit-testable without the real Google Maps API, and so
 * AppContext.js can call it without statically pulling in the Maps SDK.
 */
const circles = new Set();

export const trackServiceAreaCircle = (circle) => {
  circles.add(circle);
};

export const syncServiceAreaCircles = () => {
  const radiusM = APP.serviceRadiusKm * 1000;
  for (const circle of circles) {
    if (circle.getMap()) {
      circle.setRadius(radiusM);
      // Google Maps circles always support setCenter; the guard also keeps
      // older map adapters and lightweight test doubles compatible.
      if (typeof circle.setCenter === 'function') circle.setCenter(APP.mapCenter);
    } else {
      // Its map is gone (the screen that drew it was left) — drop it rather
      // than hold a reference for the rest of the session.
      circles.delete(circle);
    }
  }
};
